// store/balance/useBalanceStore.ts

import { create } from 'zustand';
import { persist, combine } from 'zustand/middleware';
import { CutOffActions, createCutOffSlice } from './createCutOffSlice';
import { cutOffInitialState, CutOffState } from './cutOffInitialState';

/**
 * @french
 * Hook Zustand persistant pour la gestion de la balance comptable.
 */
export const useCutOffStore = create<CutOffState & CutOffActions>()(
  persist(combine(cutOffInitialState, createCutOffSlice as any), {
    name: 'cut-off-store',
  }),
);
